import TYPES from '@/modules/shared/types';

// Domain
import {
  IncomeBehaviorInFollowingYearRepository,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/repositories/income-behavior-in-following-year-repository';
import {
  IncomeBehaviorInFollowingYearEntity,
} from '@/modules/flagship/catalogs/income-behavior-in-following-year/domain/entities/income-behavior-in-following-year-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class IncomeBehaviorInFollowingYearHttpRepository
implements IncomeBehaviorInFollowingYearRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/catalogs/income-behavior-in-following-year/`;

  execute(): Promise<Array<IncomeBehaviorInFollowingYearEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
